import { HERE_AND_NOW_TABS, type HaNSessionStorage, type HereAndNowTab } from "@lib/logic";

type StorageLike = Pick<Storage, "getItem" | "setItem">;

// The same keys and formats as legacy H&N, so a choice carries over between the two
const PREVIOUS_TAB_KEY = "HaN_Previous_Tab";
const getBuildingKey = (userId: string) => `${userId}_buildingId`;

/** Saves the chosen building and previous tab in session storage. Does nothing when the browser blocks storage. */
export const createHaNSessionStorage = (getStorage: () => StorageLike): HaNSessionStorage => {
  const read = (key: string) => {
    try {
      return getStorage().getItem(key);
    } catch {
      return null;
    }
  };

  const write = (key: string, value: string) => {
    try {
      getStorage().setItem(key, value);
    } catch {
      // Storage is unavailable, so the choice only lasts until a reload
    }
  };

  return {
    readChosenBuildingId: (userId: string) => read(getBuildingKey(userId)),

    writeChosenBuildingId: (userId: string, buildingId: string) => write(getBuildingKey(userId), buildingId),

    readPreviousTab: (): HereAndNowTab | null => {
      const tab = read(PREVIOUS_TAB_KEY)?.replace("/now/", "");

      return HERE_AND_NOW_TABS.find(knownTab => knownTab === tab) ?? null;
    },

    writePreviousTab: (tab: HereAndNowTab) => write(PREVIOUS_TAB_KEY, `/now/${tab}`),
  };
};
